import { LanguageContext } from '@nzyme/i18n/LanguageContext.js';
import { useService } from '@nzyme/vue-ioc/useService.js';
import { ConfigProvider } from 'reka-ui';
import type { ConfigProviderProps } from 'reka-ui';
import { defineComponent, h } from 'vue';

export default defineComponent({
    name: 'ConfigProvider',
    setup(_props, { slots }) {
        const languageCtx = useService(LanguageContext);
        const config: ConfigProviderProps = {
            locale: languageCtx(),
            dir: 'ltr',
            scrollBody: false,
        };

        return () => h(ConfigProvider, config, slots);
    },
});
